export default __webpack_public_path__ + "media/images/new_year/hero_5apartments-ce77918d19fa93d499cb45d1bf939a24.png";